import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { privateRoutes } from './private.routes';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { PrivateLayoutComponent } from './private-layout.component';

@NgModule({
  imports: [RouterModule.forChild(privateRoutes), SharedModule],
  declarations: [PrivateLayoutComponent],
  exports: [],
})
export class PrivateModule {}
